module.exports = __webpack_public_path__ + "static/media/orange.ebb738dc.JPG";